'use client';

import { useRouter } from 'next/navigation'

const useRedirect = () => {
  const router = useRouter()

  const handleRedirect = (url) => {
    router.push(url)
  }

  return handleRedirect
}

export default useRedirect
